export enum Languages {
  CS = 'cs',
  DE = 'de',
  EN = 'en',
  ES = 'es',
  FI = 'fi',
  FR = 'fr',
  HR = 'hr',
  HU = 'hu',
  IT = 'it',
  JA = 'ja',
  KO = 'ko',
  NL = 'nl',
  NO = 'no',
  PL = 'pl',
  PT = 'pt',
  RO = 'ro',
  RU = 'ru',
  SV = 'sv',
  TR = 'tr',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isLanguage(value: any): value is Languages {
  return Object.values(Languages).includes(value)
}
